module.exports = __webpack_public_path__ + "img/TL.39431048.svg";